var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header",attrs:{"id":"header"}},[(_vm.tln == 'home')?_c('HeaderHome',{ref:"headerHomeM"}):_vm._e(),_vm._v(" "),(_vm.tln == 'project')?_c('HeaderProject',{scopedSlots:_vm._u([{key:"pin",fn:function(){return [_vm._t("imgname")]},proxy:true}],null,true)}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46fbc9fc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Header.vue
// module id = null
// module chunks = 